export default __webpack_public_path__ + "static/media/contact.eeea87c5.jpg";